import { Nullable } from "../types/custom/Nullable";
import { Decimal } from '../types/custom/Decimal';

export const formatCurrency = (data: Nullable<Decimal>) => {
    if(data !== undefined && data !== null) {
        return data.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }

    return '';
};